import { parseISO } from 'date-fns';

const DATE_PARTS = { day: 'numeric', month: 'short', year: 'numeric' };

/**
 * A date as day, month, year in every locale ("18 Feb 2027"): the notation the
 * Battery Regulation itself uses, with the month name from the active locale.
 * A locale whose short month is a number (Bulgarian's is "02") gets the full
 * name instead ("18 февруари 2027"), never "18 02 2027".
 * `formatDateToParts` is react-intl's (`useIntl().formatDateToParts`); `date`
 * is an ISO string or a Date. Returns '' for a missing or unreadable date.
 */
export default function formatDay(formatDateToParts, date) {
    if (!date) return '';

    const value = typeof date === 'string' ? parseISO(date) : date;
    if (Number.isNaN(value.getTime())) return '';

    const parts = Object.fromEntries(formatDateToParts(value, DATE_PARTS).map(part => [part.type, part.value]));
    const month = /\d/.test(parts.month) ? formatDateToParts(value, { month: 'long' }).find(part => part.type === 'month').value : parts.month;

    return `${parts.day} ${month} ${parts.year}`;
}
